import { render, staticRenderFns } from "./LeftRightContainer.vue?vue&type=template&id=1f2ecfef&scoped=true&"
import script from "./LeftRightContainer.vue?vue&type=script&lang=js&"
export * from "./LeftRightContainer.vue?vue&type=script&lang=js&"
import style0 from "./LeftRightContainer.vue?vue&type=style&index=0&id=1f2ecfef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2ecfef",
  null
  
)

export default component.exports